import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'

const BurnRate: React.FC = () => {
  return (
    <HeaderWidget
      title='Burn Rate'
      information='This metric measures the rate at which work is being completed and helps to predict when a project will be completed. (we can correlate this with Sales down the road).'
    >
      -
    </HeaderWidget>
  )
}

export default BurnRate
